/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.8",
    versionName: "0.2.0-nightly.2025.7.8",
    versionChannel: "nightly",
    buildDate: "2025-07-08T00:07:58.488Z",
    commitHash: "d14ff13c33f081e6bdf8a52d1f26300c3606d225",
};
